/**
 * @description directive that finds the appropriate state to navigate to given the viewtype
 */

(function() {
	'use strict';

	angular
		.module('app')
		.directive('goState', goState);

	goState.$inject = ['navigationService'];

	function goState(navigationService) {
		var directive = {
			restrict: 'E',
			replace: true,
			template: template,
			link: link
		};
		return directive;

		function template(element, attrs) {
			var viewType = angular.isDefined(attrs.viewType) ? attrs.viewType : '';
			var linkName = angular.isDefined(attrs.linkName) ? attrs.linkName : '';
			var classNames = angular.isDefined(attrs.classNames) ? attrs.classNames : '';
			var translate = ' translate';
			return '<a tabIndex="0" class="' + classNames + '" ng-click="goToState(' + "'" + viewType + "'" + ')" ' + translate + '>' + linkName + '</a>';
		}

		function link(scope, element, attrs) {
			scope.goToState = function(viewType) {
				navigationService.goToState(viewType);
			};
		}
	}
})();
